import { PropsWithChildren, useMemo, useState } from "react";
import { ChatContext, ChatContextValue } from "./ChatContext";

/**
 * Holds the chat drawer's open state so any entry point (e.g. a header menu
 * item) can open it. Wrap the app shell with this, then render <Chatbot />
 * inside it.
 */
export function ChatProvider({ children }: PropsWithChildren) {
  const [isOpen, setIsOpen] = useState(false);
  const value = useMemo<ChatContextValue>(
    () => ({
      isOpen,
      open: () => setIsOpen(true),
      close: () => setIsOpen(false)
    }),
    [isOpen]
  );
  return <ChatContext.Provider value={value}>{children}</ChatContext.Provider>;
}
